import { render, staticRenderFns } from "./CathayLifeInsurance.vue?vue&type=template&id=5e700130&scoped=true"
import script from "./CathayLifeInsurance.vue?vue&type=script&lang=js"
export * from "./CathayLifeInsurance.vue?vue&type=script&lang=js"
import style0 from "./CathayLifeInsurance.vue?vue&type=style&index=0&id=5e700130&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e700130",
  null
  
)

export default component.exports